"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;

var _utils = require("../../../../utils");

var color = function (code) {
  if (code === void 0) {
    code = '';
  }

  code = code.toLowerCase();

  switch (code) {
    case 'elevated':
      return '#ffb367';

    case 'critical':
      return '#ff666a';

    case 'extreme':
      return '#fe59ff';

    default:
      return '#000000';
  }
};
/**
 * @private
*/


var config = {
  data: {
    request: {
      endpoint: 'fires/outlook',
      action: "search"
      /* SEARCH */
      ,
      parameters: {
        filter: 'geo'
      }
    },
    properties: {
      id: 'id',
      path: 'geoPoly',
      category: 'details.risk.type',
      timestamp: {
        from: 'details.range.minTimestamp',
        to: 'details.range.maxTimestamp'
      }
    }
  },
  style: {
    polygon: function (data) {
      var type = (0, _utils.get)(data, 'details.risk.type');
      return {
        fill: {
          color: color(type),
          opacity: 0.7
        }
      };
    }
  }
};
exports.config = config;
var _default = config;
exports.default = _default;